const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const ApplicationFormSchema = (data) => {
    const schema = Joi.object({
        arrestMonth: Joi.string()
            .pattern(/^(0[1-9]|1[0-2])$/, "month")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Month_Format,
                "string.empty": currentLang?.ValidationSchema?.Month_Required,
            }),
        arrestDay: Joi.string()
            .pattern(/^(0[1-9]|[1-2][0-9]|3[0-1])$/, "day")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Day_Format,
                "string.empty": currentLang?.ValidationSchema?.Day_Required,
            }),
        arrestYear: Joi.string()
            .pattern(/^(19|20)\d{2}$/, "year")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Year_Format,
                "string.empty": currentLang?.ValidationSchema.Year_Required,
            }),

        offenseMonth: Joi.string()
            .pattern(/^(0[1-9]|1[0-2])$/, "month")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Month_Format,
                "string.empty": currentLang?.ValidationSchema?.Month_Required,
            }),
        offenseDay: Joi.string()
            .pattern(/^(0[1-9]|[1-2][0-9]|3[0-1])$/, "day")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Day_Format,
                "string.empty": currentLang?.ValidationSchema?.Day_Required,
            }),
        offenseYear: Joi.string()
            .pattern(/^(19|20)\d{2}$/, "year")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Year_Format,
                "string.empty": currentLang?.ValidationSchema.Year_Required,
            }),


        courtMonth: Joi.string()
            .pattern(/^(0[1-9]|1[0-2])$/, "month")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Month_Format,
                "string.empty": currentLang?.ValidationSchema?.Month_Required,
            }),
        courtDay: Joi.string()
            .pattern(/^(0[1-9]|[1-2][0-9]|3[0-1])$/, "day")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Day_Format,
                "string.empty": currentLang?.ValidationSchema?.Day_Required,
            }),
        courtYear: Joi.string()
            .pattern(/^(19|20)\d{2}$/, "year")
            .required()
            .messages({
                "string.pattern.base": currentLang?.ValidationSchema?.Year_Format,
                "string.empty": currentLang?.ValidationSchema.Year_Required,
            }),
        court: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        countyName: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        caseNumber: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        charges: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        // AuthorizationCharges: Joi.string()
        //     .required()
        //     .trim()
        //     .messages({
        //         "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
        //         "any.required": currentLang?.ValidationSchema?.The_Field_Required,
        //     }),
        address: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        guardianAddress: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        city: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        state: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        zip: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        guardianName: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        maritalStatus: Joi.number()
            .required()
            .messages({
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        netIncome: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        courtOrderedPayment: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        caseTotal: Joi.string()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        realEstate: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        isDisabled: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        claimsAsDependent: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        receivesBenefits: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        receivesWorkCompensation: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        receivesChildSupport: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        employed: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        ssnFirst: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        ssnSecond: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        ssnThird: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        TotalBondAmount: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        incomeInJail: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        PostYourBond: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        BondPersonAddressPhone: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        pdsInmateSignature: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        // caseNo: Joi.string()
        //     .required()
        //     .trim()
        //     .messages({
        //         "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
        //         "any.required": currentLang?.ValidationSchema?.The_Field_Required,
        //     }),
        // clientSignature: Joi.string()
        //     .required()
        //     .trim()
        //     .messages({
        //         "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
        //         "any.required": currentLang?.ValidationSchema?.The_Field_Required,
        //     }),
        // facilityName: Joi.string()
        //     .required()
        //     .trim()
        //     .messages({
        //         "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
        //         "any.required": currentLang?.ValidationSchema?.The_Field_Required,
        //     }),
        acknowledgeMent: Joi.valid(true)
            .required()
            .messages({
                "any.only": currentLang?.ValidationSchema?.Form_Field_Required, // Custom error for non-true values
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required, // Custom error for missing field
            }),
        spouseName: Joi.string()
            .trim()
            .when('maritalStatus', {
                is: 4,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.spouseName_Required,
                    "any.required": currentLang?.ValidationSchema?.spouseName_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        spouseEmployedWhere: Joi.string()
            .trim()
            .when('spouseEmployed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.The_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.The_Field_Required,
                }),
                otherwise: Joi.allow('').optional(), // For other statuses
            }),
        spouseEmployed: Joi.alternatives().conditional('maritalStatus', {
            is: 4, // If maritalStatus is 4
            then: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.allow('').optional(), // For other statuses
        }),
        incomeType: Joi.alternatives().conditional('spouseEmployed', {
            is: 1, // If maritalStatus is 4
            then: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),
        spouseIncome: Joi.string()
            .trim()
            .when('spouseEmployed', {
                is: 1,
                then: Joi.required().messages({
                    "any.required": currentLang?.ValidationSchema?.spouseIncome_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        netIncomeType: Joi.alternatives().conditional('netIncome', {
            is: Joi.string().pattern(/^\s*$/).not('').required(), // Ensures `netIncome` is not an empty string or only spaces
            then: Joi.string().allow('').optional(), // If `netIncome` is empty or just spaces, allow `netIncomeType` as empty or string
            otherwise: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        }),
        childSupportObligationType: Joi.alternatives().conditional('childSupportObligation', {
            is: "", // Matches empty string or spaces
            then: Joi.string().allow('').optional(), // vehicleEstValue is optional if vehicleModel is empty
            otherwise: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        }),
        disabilityType: Joi.alternatives().conditional('isDisabled', {
            is: 1, // If maritalStatus is 4
            then: Joi.string().required().messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),
        dependentName: Joi.alternatives().conditional('claimsAsDependent', {
            is: 1, // If maritalStatus is 4
            then: Joi.string().required().messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),
        vehicleEstValue: Joi.alternatives().conditional('vehicleModel', {
            is: "", // Matches empty string or spaces
            then: Joi.string().allow('').optional(), // vehicleEstValue is optional if vehicleModel is empty
            otherwise: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.This_Field_Required_VechicleModel_Provided,
            }),
        }),

        equityValue: Joi.alternatives().conditional('realEstate', {
            is: 1,
            then: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),

        employerDetails: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        jobTitle: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        lengthOfJob: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        priorEmployment: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        incomeInJailAmount: Joi.string()
            .trim()
            .when('incomeInJail', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        childSupportAmount: Joi.string()
            .trim()
            .when('receivesChildSupport', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        workCompensationAmount: Joi.string()
            .trim()
            .when('receivesWorkCompensation', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        benefitsAmount: Joi.string()
            .trim()
            .when('receivesBenefits', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        equityValue: Joi.alternatives().conditional('realEstate', {
            is: 1,
            then: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false, // Shows all validation errors instead of stopping at the first error
    });
};

module.exports = ApplicationFormSchema;
